const React = require('react');
const noop = require('mn-utils/noop');
const withState = require('../../../../utils/withState');
const {
  apiAdminMaintenanceGet,
  apiAdminMaintenanceDisable,
  apiAdminMaintenanceEnable,
} = require('../../../../api/admin/maintenance');
const SwitchA = require('../../../dumb/Switch/A');
const WrapperWithLoading = require('../../../dumb/WrapperWithLoading');


module.exports = withState((setState, self, onMount) => {
  let _cancelMaintenance = noop;
  onMount(() => {
    setState({
      loadingMaintenance: 1,
    });
    _cancelMaintenance = apiAdminMaintenanceGet().finally((error, response) => {
      setState({
        maintenanceMode: response && response.enabled || false,
        loadingMaintenance: 0,
      });
    }).cancel;
    return () => {
      _cancelMaintenance();
    };
  });

  return (state) => {
    const maintenanceMode = state.maintenanceMode || false;

    return (
      <WrapperWithLoading
        loading={state.loadingMaintenance}
      >
        <SwitchA
          label="Maintenance mode"
          checked={maintenanceMode}
          onChange={() => {
            setState({
              loadingMaintenance: 1,
            });
            if (maintenanceMode) {
              _cancelMaintenance = apiAdminMaintenanceDisable()
                  .finally((error, response) => {
                    setState({
                      loadingMaintenance: 0,
                      maintenanceMode: error ? maintenanceMode : false,
                    });
                  }).cancel;
              return;
            }
            _cancelMaintenance = apiAdminMaintenanceEnable()
                .finally((error, response) => {
                  setState({
                    loadingMaintenance: 0,
                    maintenanceMode: error ? maintenanceMode : true,
                  });
                }).cancel;
          }}
        />
      </WrapperWithLoading>
    );
  };
}, {});
